import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {StoreService} from "../../services/store.service";
import {DebtPositionsService} from "../../services/personal-area/debt-positions/debt-positions.service";
import {Subject, takeUntil} from "rxjs";
import {NgxSpinnerService} from "ngx-spinner";
import {ToolsService} from "../../../../../../shared/src/lib/services/tools.service";
import {AuthService} from "../../services/auth/auth.service";
import {NavigationEnd, Router} from "@angular/router";
import {pathSegmentContainsPersonalRoute} from "../../modules/cart-icon-header/cart-icon-header.component";
import {ModalService} from "../../services/modal.service";

@Component({
    selector: 'new-common-header',
    templateUrl: './new-common-header.component.html',
    styleUrls: ['./new-common-header.component.scss'],
    standalone: false
})
export class NewCommonHeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  personalData$ = this.authService.decodedJWT$;
  isLogged$ = this.authService.isLogged$;
  pathname: string = '';
  dataAggiornamento$ = this.storeService.dataAggiornamento$
  disableAggiornamentoButton$ = this.storeService.disableAggiornamentoButton$
  public authorityId: string = '';
  private onDestroy$ = new Subject<void>();
  public isPersonalRoute: boolean;
  isUserMenuOpened = false;
  isGeneralMenuOpened = false;

  constructor(
    public router: Router,
    public translateService: TranslateService,
    public storeService: StoreService,
    public debtsPositionService: DebtPositionsService,
    private spinner: NgxSpinnerService,
    private toolsService: ToolsService,
    private authService: AuthService,
    private modalService: ModalService,
  ) {
    this.isPersonalRoute = this.router.url.includes(pathSegmentContainsPersonalRoute)
    this.router.events
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(e => {
        if (e instanceof NavigationEnd) {
          this.pathname = location.pathname;
          this.isPersonalRoute = e.url.includes(pathSegmentContainsPersonalRoute);
          this.isUserMenuOpened = false;
        }
      })
  }
  ngOnInit() {
    this.authorityId = this.storeService.codIpa
    // chiamata a getAuthorityInfo; commentate quelle in "InfoComponent" e "AuthorityIdResolver"
    this.storeService.getAuthorityInfo();
    this.translateService.use(this.translateService.currentLang);
  }
  ngAfterViewInit(): void {
    // fixme this code trigger a lot of time the angular change detection;
    setTimeout(() => {
      this.toolsService.loadScript("assets/gb/js/main.js");
    }, 600);
  }
  logoutAndGoToHome() {
    this.modalService.showModal("alert_multiutente")
  }
  aggiorna() {
    const personalData = this.authService.getDecodedJWT();
    if (!!personalData) {
      this.spinner.show()
      this.debtsPositionService.putPositionsPersonalArea(personalData.fiscalNumber, this.authorityId)
    }
  }
  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete();
  }
  askToLogout() {
    this.modalService.showModal("alert_multiutente")
  }
  toggleUserMenu() {
    this.isUserMenuOpened = !this.isUserMenuOpened
  }
  openGeneralMenu() {
    this.isGeneralMenuOpened = !this.isGeneralMenuOpened
  }
  openNotificationsModal() {
    this.modalService.showModal("ente-notifications");
  }

}
